<template>
  <v-container id="fcreate">
    <v-row>
      <v-col cols="12" md="7">
        <div
          class="text-h3 mb-2"
          v-text="'Редактирование ' + (getName || 'безымянного сотрудника')"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-form v-model="valid" ref="form">
          <v-container fluid>
            <v-row>
              <v-col cols="12" md="7">
                <v-text-field
                  v-model="data.name"
                  outlined
                  label="Имя"
                  required
                  :rules="rules.required"
                  :loading="loading"
                  :disabled="loading"
                />
              </v-col>
              <v-col cols="12" md="7">
                <v-text-field
                  v-model="data.phone"
                  v-mask="'+#(###)###-##-##'"
                  outlined
                  label="Телефон"
                  required
                  :rules="rules.phone"
                  :loading="loading"
                  :disabled="loading"
                />
              </v-col>
              <v-col cols="12" md="7">
                <v-text-field
                  v-model="data.email"
                  outlined
                  label="Email"
                  required
                  :rules="rules.email"
                  :loading="loading"
                  :disabled="loading"
                />
              </v-col>
              <v-col cols="12" md="7">
                <v-btn class="mb-2" color="primary" block @click="save">
                  Сохранить
                </v-btn>
                <v-btn class="mb-2" color="success" block @click="save(false)">
                  Применить
                </v-btn>
                <v-btn color="error" block @click="$router.push('/clients')">
                  Отменить
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      </v-col>
    </v-row>
    <v-snackbar v-model="snackbar">
      Исправьте ошибки и повторите попытку
      <template v-slot:action="{ attrs }">
        <v-btn
          color="red"
          text
          v-bind="attrs"
          @click="snackbar = false"
        >
          Закрыть
        </v-btn>
      </template>
    </v-snackbar>
    <v-snackbar v-model="snackbarSuccess">
      Измемнения сохранены
      <template v-slot:action="{ attrs }">
        <v-btn
          color="red"
          text
          v-bind="attrs"
          @click="snackbar = false"
        >
          Закрыть
        </v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
  import { mapGetters } from 'vuex'
  import rules from '@/mixins/rules'

  export default {
    mixins: [rules],
    data () {
      return {
        data: {},
        valid: false,
        loading: false,
        loadingForm: false,
        snackbar: false,
        snackbarSuccess: false,
      }
    },
    computed: {
      ...mapGetters({
        getClientsSingle: 'clients/getClientsSingle',
      }),
      getId () { return this.$route.params.id || null },
      getName () { return this.getClientsSingle ? this.getClientsSingle.name : '' },
      getPhone () { return this.getClientsSingle ? this.getClientsSingle.phone : '' },
      getFormatedPhone () { return this.getPhone ? this.getPhone.match(/[0-9]/g) : '' },
    },
    async created () {
      if (this.getId) {
        this.loading = true
        this.$store
          .dispatch('clients/fetchSingleClients', this.getId)
          .then((res) => {
            if (res.status === 200) {
              this.loading = false

              this.editClients()
            }
          })
          .catch(() => {
            this.loading = false
          })
      } else {
        this.$router.push('/clients')
      }
    },
    beforeDestroy () {
      this.$store.commit('clients/clearClientsSingle')
    },
    methods: {
      editClients () {
        this.data = {
          phone: this.getClientsSingle.phone,
          email: this.getClientsSingle.email,
          name: this.getClientsSingle.name,
          status: this.getClientsSingle.status,
        }
      },
      async save (redirect = true) {
        const valid = this.$refs.form.validate()

        if (valid) {
          this.loadingForm = true

          this.$store
            .dispatch('clients/editClients', { data: this.data, id: this.getId })
            .then((res) => {
              if (res.status === 200) {
                this.loadingForm = false
                if (redirect) this.$router.push('/clients')
                else {
                  this.snackbarSuccess = true
                  setTimeout(() => {
                    this.snackbarSuccess = false
                  }, 3000)
                }
              }
            })
            .catch((err) => {
              this.loadingForm = false
              console.log(err)
            })
        } else {
          this.snackbar = true
          document.getElementById('fcreate').scrollIntoView({
            behavior: 'smooth',
          })

          setTimeout(() => {
            this.snackbar = false
          }, 3000)
        }
      },
    },
  }
</script>
